import React from 'react';

import { LOCAL_COLORS } from 'styles/constants';

import { ANTI_AGING, INGREDIENTS } from './ingredients-info';
import type { IngredientsProps } from '../Ingredients';

export const INGREDIENTS_RETAIL_OFFER_CONTENT: IngredientsProps = {
  header: (
    <React.Fragment>
      Clinically-proven ingredients, <br />
      picked for your goals
    </React.Fragment>
  ),
  ingredients: INGREDIENTS[ANTI_AGING],
  backgroundColor: LOCAL_COLORS.surfaceLight,
};
